import { css } from '@emotion/react'
import {
  breakpoint,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const container = css`
  display: flex;
  flex-direction: column;
  gap: ${size[24]};
`

export const shopsWrap = css`
  overflow: auto;
  width: 100%;

  ${breakpoint.up('smMd')} {
    display: contents;
  }
`

export const shops = css`
  position: relative;
  display: grid;
  grid-auto-flow: dense;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: ${size[12]};
  margin-bottom: ${size[32]};
  width: ${width.container.wide};

  ${breakpoint.up('smMd')} {
    margin-bottom: ${size[56]};
    gap: ${size[24]};
    width: unset;
    grid-template-rows: initial;
    grid-template-columns: repeat(10, 1fr);
  }
`

export const name = css`
  font-size: ${pxToRem(36)};
  font-weight: 700;

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(48)};
  }
`
